export const SESSION_EXPIRED_ALERT_ID = "SESSION_EXPIRED_ALERT_ID";
